import { render, staticRenderFns } from "./AdminTab_Role.vue?vue&type=template&id=9be2cdec&scoped=true"
import script from "./AdminTab_Role.vue?vue&type=script&lang=js"
export * from "./AdminTab_Role.vue?vue&type=script&lang=js"
import style0 from "./AdminTab_Role.vue?vue&type=style&index=0&id=9be2cdec&prod&scoped=true&lang=css"
import style1 from "./AdminTab_Role.vue?vue&type=style&index=1&id=9be2cdec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be2cdec",
  null
  
)

export default component.exports